import React from 'react'
import './item.css'

class OpenItem extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <div className="item-entry">
                    <div className="item-entry-left">
                        <div className="item-left-point"></div>
                    </div>
                    <div className="item-entry-middle">
                        <p className="item-middle-word">{this.props.name}</p>
                        <p className="item-middle-time">{this.props.time}</p>
                    </div>
                    <div className="item-entry-right">
                        <div className='item-right-openbox'>
                            <img className="item-right-img" src={require("../assert/link_orange.png")}></img>
                            <img className="item-right-img" src={require("../assert/data_orange.png")}></img>
                            <img className="item-right-img" src={require("../assert/edit_orange.png")}></img>
                            <img className="item-right-img" src={require("../assert/set_orange.png")}></img>
                            <img className="item-right-img" src={require("../assert/delete_orange.png")}></img>
                        </div>
                    </div>
                </div>
                <div className="item-aline">

                </div>
            </div>

        );
    }
}

class CloseItem extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <div className="item-entry">
                    <div className="item-entry-left">
                        <div className="item-left-point"></div>
                    </div>
                    <div className="item-entry-middle">
                        <p className="item-middle-word">{this.props.name}</p>
                        <p className="item-middle-time">{this.props.time}</p>
                    </div>
                    <div className="item-entry-right">
                        <div className='item-right-box'>
                            <img className="item-right-img" src={require("../assert/edit_orange.png")}></img>
                            <img className="item-right-img" src={require("../assert/set_orange.png")}></img>
                            <img className="item-right-img" src={require("../assert/delete_orange.png")}></img>
                        </div>
                    </div>
                </div>
                <div className="item-aline">

                </div>
            </div>

        );
    }
}

export {OpenItem, CloseItem};